import React, { useEffect, useState } from 'react';
import Modal from 'components/Tvendo/Common/ModalBase';
import TextField from '@material-ui/core/TextField';
import { WithApp } from 'contexts/appContext';
import moment from 'moment';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

export default WithApp(function ModalProductGroup(props) {
  const group = props.model;
  const [dataChanging, setDataChanging] = useState({});

  function handleChange(field, value) {
    setDataChanging((prev) => ({ ...prev, [field]: value }));
  }

  useEffect(() => {
    if (group.length > 0 && group.type) {
      handleChange("type", String(group.type));
    }
  },[group]);

  return (
    <>
      <Modal
        title={`Grupo de Productos Clorox`}
        model={group}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity="sale/clorox-group-products"
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="Periodo"
          margin="normal"
          defaultValue={moment(group.valueSearch?.Periodo).format('YYYY-MM') || ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
          required
        />
        <TextField
          label="Descripción"
          fullWidth
          type="text"
          name="description"
          margin="normal"
          defaultValue={!!group ? group.description : ''}
          onChange={(e) => handleChange('description', e.target.value)}
          required
        />
        <FormControl fullWidth margin="normal" size="small">
          <InputLabel>Tipo</InputLabel>
          <Select
            required
            defaultValue={!!group ? group.type : ''}
            inputProps={{
              name: 'type',
            }}
          >
            <MenuItem value="O">Venta</MenuItem>
            <MenuItem value="I">Compra</MenuItem>
            <MenuItem value="C">Cobertura</MenuItem>
            <MenuItem value="U">Unidades</MenuItem>
          </Select>
        </FormControl>
      </Modal>
    </>
  );
});
